import React, { useEffect, useRef, useState } from "react";
import styles from "./styles/login.module.css";
import UploadLogoButton from "../components/UploadLogoButton/UploadLogoButton";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import upwardarrow from "../assests/Upwardarrow/upwardArrow.svg";
import { MdCloudDone } from "react-icons/md";
function GetEmail() {
  const [email, setEmail] = useState(false);
  const [viewgdpr, setviewgdpr] = useState(false);
  const emailRef = useRef();
  const navigate = useNavigate();

  const Sendmail = (e) => {
    e.preventDefault();

    const emailVal = emailRef.current.value;
    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (!email) {
      if (emailVal.match(regex)) {
        // e.target.innerText = "Loading..."
        fetch("https://friendly-jepsen.77-68-82-89.plesk.page/email", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ email }),
        })
          .then((res) => res.json())
          .then(({ status, email, msg }) => {
            if (status == "failed" && msg) {
              Swal.fire({
                icon: "error",
                title: "Some error occur!",
                text: msg,
              });
            } else {
              // e.target.innerText = "Submit"
              localStorage.setItem("rgs_email", emailVal);
              setEmail(true);
              navigate("/logo-upload");

            }
          });
      } else
        Swal.fire({
          icon: "error",
          title: "Email is invalid!",
          text: "please enter emial correctly",
        });
    }
  };

  return (
    <>
      <div className={`${styles.login} ${viewgdpr && "mb-[500px]"}`}>
        <h1 className="mb-6">Great things await…</h1>
        <p>
          Simply enter your email address to begin.
          <br />
          Your email will allow you to save and edit your design.
        </p>
        <div className="w-[350px] h-[50px] my-3 mb-5 rounded-md relative">
          <input
            className="h-full w-full pl-5"
            type="email"
            name="Email"
            placeholder="Email* (Required)"
            defaultValue={localStorage.getItem("rgs_email") || ""}
            onChange={() => {
              email && setEmail(false);
            }}
            ref={emailRef}
          />
          {email && (
            <MdCloudDone className="text-[green] text-2xl absolute right-[50px] top-[50%] translate-y-[-50%]" />
          )}
          {/* <button className='absolute right-[10px] top-[50%] translate-y-[-50%] bg-black text-white py-1 px-3 rounded-3xl' onClick={Sendmail}>Submit</button> */}
          <div
            className="rounded-full h-8 w-8 bg-gray-300 flex justify-center p-1 cursor-pointer absolute right-[5px] top-[50%] translate-y-[-50%]  transform rotate-90"
            onClick={Sendmail}
          >
            <img
              className="w-4 h-4 mt-1 cursor-pointer"
              src={upwardarrow}
              alt="Upward Arrow"
            />
          </div>
          {/* {!email && <p className='absolute right-[10px] bottom-[-30px] text-right'>Submit Email to proceed</p>} */}
          <div className="text-center justify-center items-center mt-10">
            <p
              className="inline-block hover:underline text-[#252525] cursor-pointer"
              onClick={() => setviewgdpr(!viewgdpr)}
            >
              Our GDPR compliance
            </p>
            {viewgdpr && (
              <p className="text-left mt-4">
                Parify Group Ltd is committed to ensuring the security and
                protection of the personal information that we process, and to
                provide a compliant and consistent approach to data protection.
                We have created this GDPR Compliance Statement to explain our
                approach to implementing our GDPR compliance program. It
                describes the implementation of our data protection roles,
                policies, procedures, controls and measures to ensure ongoing
                compliance with GDPR. Our GDPR Principles Parify Group Ltd takes
                the privacy and security of individuals and their personal
                information very seriously.<br/> Our principles for processing
                personal information are:
                <br/> • We will process all personal
                information fairly and lawfully<br/> • We will only process personal
                information for specified and lawful purposes <br/>• Where practical,
                we will keep personal information up to date <br/>• We will not keep
                personal information for longer than is necessary
              </p>
            )}
          </div>
        </div>
        {/* <div className='flex items-center gap-2'>
          <UploadLogoButton
            text={"UPLOAD LOGO"}
            style={"gap-[30px] my-5 w-[250px]"}
            btnID={"all"}
            disabled={!email}
            getEmail
          />
          <button className='bg-black h-[40px] text-white py-2 px-5 rounded-[30px] disabled:cursor-not-allowed ml-2' disabled={!email} onClick={() => navigate("/home")}>Go to Design</button>
        </div> */}
        {/* <p>We recommend a PNG file for the best visual result</p> */}
      </div>
    </>
  );
}
export default GetEmail;
